export const getAnnotationVideoTime = (annotation, frames) => {
  if (frames?.length) {
    const frameRate = process.env.REACT_APP_ENGINE_FRAME_RATE;
    const index = frames.findIndex((frame) => frame.id === annotation.specification_frame.id);
    const time = index / frameRate;
    return time;
  }
  return 0;
};
